// extracted by mini-css-extract-plugin
export default {"boxVideoThumbnail":"BoxVideoThumbnail_boxVideoThumbnail__WXeI4","isPreview":"BoxVideoThumbnail_isPreview__V4PGj"};